<div class="t-content" id="cruiser">
  <form (ngSubmit)="_onSubmit(_form, $event)" [formGroup]="_form" novalidate>
    <div class="form-row pb-5">
      <div class="form-group col-xg-12 col-lg-3 col-md-12 col-sm-12">
        <label for="destination"></label>
        <input ngui-auto-complete formControlName='destination' maxlength="20" type="text" name="destino"
          class="form-control inp input-search-box" value-formatter="cityName" placeholder="Destination" [(ngModel)]="destiny"
          [source]="observableSource.bind(this)" display-property-name="cityName" (valueChanged)="_myCallback($event)"
          [list-formatter]="_myListFormatter" autocomplete="off" #destination>
        <span class="help-block text-danger"
          *ngIf="_form.get('destination').touched && _form.get('destination').hasError('required')">This field is
          required.</span>
        <span class="help-block text-danger"
          *ngIf="_form.get('destination').touched && _form.get('destination').hasError('invalidcountry')">Invalid
          destination format.</span>
        <span class="help-block text-danger"
          *ngIf="_form.get('destination').touched && _form.get('destination').hasError('invalidDestination')">Invalid
          destination, please select a valid destination from the list.</span>
      </div>
      <div class="form-group col-xg-2 col-lg-2 col-md-12 col-sm-12">
        <ng-select formControlName="months" [items]="months" bindLabel="name" bindValue="id"
          [(ngModel)]="selectedMonthsId" class="custom select-custom" placeholder="Departure month">
        </ng-select>
      </div>
      <div class="form-group col-xg-2 col-lg-2 col-md-12 col-sm-12">
        <ng-select formControlName="durations" [items]="duration" bindLabel="name" bindValue="id"
          placeholder="Durations" [(ngModel)]="selectedDurationsId" class="custom select-custom">
        </ng-select>
      </div>
      <!-- desplegable selector de pasajeros  -->
      <div class="form-group col-xg-2 col-lg-3 col-md-12 col-sm-12">
        <button type="button" class="form-control btn-usb-rp" (click)="_openModal()" [attr.aria-expanded]="!isCollapsed"
          aria-controls="false">
          Passengers
          <span class="arrow-sort fas fa-sort"></span>
        </button>
        <div (collapsed)="clickOutside($event)" (expanded)="($event)" [collapse]="!isCollapsed || _close"
          (click)="_over()">
          <div class="row">
            <div class="col-xg-12 col-lg-12 col-md-12 col-sm-12 w-100">
              <div class="card px-3">
                <div
                  class="d-flex flex-row align-items-start justify-content-start py-2">
                  <div class="d-flex flex-column mr-2">
                    <label for="adults">Adults</label>
                    <select formControlName="qtyAdults" class="custom-select form-control-sm" id="adults" name="adults"
                      [value]="0">
                      <option *ngFor="let qty of _maxPersons" [value]="qty">{{ qty }}</option>
                    </select>
                  </div>
                  <div class="d-flex flex-column">
                    <label for="childs">Children</label>
                    <select formControlName="qtyChilds" class="custom-select form-control-sm" id="childs"
                      (ngModelChange)="_addChild()" name="childs" [value]="0">
                      <option *ngFor="let qty of _maxPersons" [value]="qty">{{ qty }}</option>
                    </select>
                  </div>
                  <div class="px-2 d-flex w-100">
                    <!-- Children age inputs -->
                    <div id="childrenAges" class="col-12 m-0 p-0" *ngIf="formArray(_form, 'childsage').length > 0">
                      <label for="age">Edad niños</label>
                      <div class="d-flex flex-column">
                        <div class="d-flex flex-row p-0 m-0">
                          <div formArrayName="childsage" *ngFor="let age of formArray(_form, 'childsage'); let j = index;"
                            class="col-3 mr-1 select-ages">
                            <div [formGroupName]="j" class="col-12" style="padding:0px;">
                              <input formControlName="age" min=0 max=17 limit-to="14"
                                class="form-control col-10 input-age" placeholder="0" name="age">
                            </div>
                          </div>
                        </div>
                        <div *ngFor="let age of formArray(_form, 'childsage'); let j = index;">
                          <span class="help-block text-danger d-flex w-100 text-nowrap"
                            *ngIf="age.controls['age'].hasError('invalidsoloNumeros') || age.controls['age'].hasError('min') || age.controls['age'].hasError('max') || age.controls['age'].hasError('required')"><br>Age
                            of children {{j+1}} is incorrect</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <hr>
                <div class="d-flex justify-content-end flex-row">
                  <div class="p-2 justify-content-end">
                    <button (click)="_confirm()" [attr.aria-expanded]="!isCollapsed" aria-controls="false"
                      class="btn btn-outline-danger btn-sm" type="button">
                      Confirm
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="form-group col-xs-12 col-lg-2 col-md-4 justify-content-start align-middle ">
        <button class="btn btn-usblick" type="submit"
          [disabled]="(!_form.valid || _findData || userService.itineraryActive.length == 0)">
          <i class="{{_findData?'fas fa-spinner fa-spin fa-sm':''}}"></i>
          Start
        </button>
      </div>
    </div>

  </form>

</div>